//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Issue/Issue.IssueContent.js";
let d=[[],[],[]];
SPLM.Features.ShipDesign.PenetrationRequest = class extends SPLM.Issue.IssueContent{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.PenetrationRequest";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.PenetrationRequest.RequestType = Object.freeze({
    "Single" : "Single", "Multiple" : "Multiple"});

SPLM.Features.ShipDesign.PenetrationRequest.PenetrationType = Object.freeze({
    "PenetratingObject" : "PenetratingObject", "PenetratingPoint" : "PenetratingPoint"});

SPLM.Features.ShipDesign.PenetrationRequest.CoutoutType = Object.freeze({
    "Circular" : "Circular", "Rectangular" : "Rectangular", "FlatOval" : "FlatOval", "UserDefined" : "UserDefined", "ExistingSketch" : "ExistingSketch", "NewSketch" : "NewSketch", "None" : "None"});

SPLM.Features.ShipDesign.PenetrationRequest.DirectionType = Object.freeze({
    "PerpendiculartoStructure" : "PerpendiculartoStructure", "ParalleltoRoute" : "ParalleltoRoute", "UserDefined" : "UserDefined"});

SPLM.Features.ShipDesign.PenetrationRequest.CompensationType = Object.freeze({
    "NotRequired" : "NotRequired", "Standard" : "Standard", "NonStandard" : "NonStandard", "Sleeve" : "Sleeve", "DoubleSleeve" : "DoubleSleeve", "Flange" : "Flange"});

export default SPLM;